'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { OFFSCREEN_POSITION } from 'InpageEditorUI/lib/layoutSection/constants';
import { connect } from 'react-redux';
import { getCurrentModuleToolbarInfo, getCurrentEmptyContainerToolbarInfo, getCurrentRowToolbarInfo, getCurrentTopmostRowToolbarInfo, getCurrentColumnToolbarInfo, getCurrentInsertNewSectionToolbarInfo, getHasTopmostRowToolbarHoveredOrSelected, getHasRowToolbarHoveredOrSelected, getHasColumnToolbarHoveredOrSelected, getShouldShowGridAndToolbars, getHasAllResponsiveToolbarMeasurements } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { layoutSectionHoverPositionsFrozen as layoutSectionHoverPositionsFrozenAction, layoutSectionHoverPositionsThawed as layoutSectionHoverPositionsThawedAction } from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
import { getIsInDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import ResponsiveSectionToolbar from 'InpageEditorUI/components/responsiveToolbar/ResponsiveSectionToolbar';
import ResponsiveInsertNewSectionHandle from 'InpageEditorUI/components/responsiveToolbar/ResponsiveInsertNewSectionHandle';
import ResponsiveColumnToolbar from 'InpageEditorUI/components/responsiveToolbar/ResponsiveColumnToolbar';
import ResponsiveRowToolbar from 'InpageEditorUI/components/responsiveToolbar/ResponsiveRowToolbar';
import ResponsiveToolbarInDndArea from 'InpageEditorUI/components/responsiveToolbar/ResponsiveToolbarInDndArea';
import ResponsiveToolbarOutsideContainer from 'InpageEditorUI/components/responsiveToolbar/ResponsiveToolbarOutsideContainer';
import ResponsiveToolbarInFlexColumn from 'InpageEditorUI/components/responsiveToolbar/ResponsiveToolbarInFlexColumn';
import ResponsiveEmptyContainerToolbar from 'InpageEditorUI/components/responsiveToolbar/ResponsiveEmptyContainerToolbar';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { ResponsiveToolbarInRichText } from '../components/responsiveToolbar/ResponsiveToolBarInRichText';
import { getIsDataAuthoringModeActive } from 'ContentEditorUI/redux/selectors/instanceEditingSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => ({
  moduleToolbarInfo: getCurrentModuleToolbarInfo(state),
  emptyContainerToolbarInfo: getCurrentEmptyContainerToolbarInfo(state),
  rowToolbarInfo: getCurrentRowToolbarInfo(state),
  sectionToolbarInfo: getCurrentTopmostRowToolbarInfo(state),
  insertNewSectionToolbarInfo: getCurrentInsertNewSectionToolbarInfo(state),
  columnToolbarInfo: getCurrentColumnToolbarInfo(state),
  hasTopmostRowToolbarHoveredOrSelected: getHasTopmostRowToolbarHoveredOrSelected(state),
  hasRowToolbarHoveredOrSelected: getHasRowToolbarHoveredOrSelected(state),
  hasColumnToolbarHoveredOrSelected: getHasColumnToolbarHoveredOrSelected(state),
  shouldShowGridAndToolbars: getShouldShowGridAndToolbars(state),
  hasAllResponsiveToolbarMeasurements: getHasAllResponsiveToolbarMeasurements(state),
  isInDefaultBreakpointMode: getIsInDefaultBreakpointMode(state),
  isDataAuthoringModeActive: getIsDataAuthoringModeActive(state)
});
const mapDispatchToProps = dispatch => ({
  dispatch,
  layoutSectionHoverPositionsFrozen: () => dispatch(layoutSectionHoverPositionsFrozenAction()),
  layoutSectionHoverPositionsThawed: () => dispatch(layoutSectionHoverPositionsThawedAction())
});
const renderResponsiveSectionToolbar = (moduleToolbarInfo, sectionToolbarInfo, bus, isHoveredOrSelected, dispatch, handlePreDragMouseDown, handleToolbarDropdownOpenChange, shouldShowGridAndToolbars, isCommentable) => {
  // Have the default position be way off screen to prevent borders from bleeding onto the page. Plus,
  // we intentionally render offscreen instead of rendering null for perf (far less mount/unmount churn)
  const {
    id,
    layoutSectionId,
    top = OFFSCREEN_POSITION.TOP,
    left = OFFSCREEN_POSITION.LEFT,
    responsiveSize
  } = sectionToolbarInfo || {};
  return /*#__PURE__*/_jsx(ResponsiveSectionToolbar, {
    id: id,
    layoutSectionId: layoutSectionId,
    active: isHoveredOrSelected,
    responsiveSize: responsiveSize,
    top: Math.round(top),
    left: Math.round(left),
    onHandleMouseDown: handlePreDragMouseDown,
    onDropdownOpenChange: handleToolbarDropdownOpenChange,
    bus: bus,
    dispatch: dispatch,
    isCommentable: isCommentable
  });
};
const renderResponsiveToolbar = (moduleToolbarInfo, bus, dispatch, handlePreDragMouseDown, handleToolbarDropdownOpenChange, isDataAuthoringModeActive = false, isCommentable) => {
  // Have the default position be way off screen to prevent borders from bleeding onto the page. Plus,
  // we intentionally render offscreen instead of rendering null for perf (far less mount/unmount churn)
  const {
    id,
    layoutSectionId,
    top = OFFSCREEN_POSITION.TOP,
    left = OFFSCREEN_POSITION.LEFT,
    responsiveSize,
    isFixedPosition,
    isPostBodyModule,
    isStaticModule,
    isFlexColumnModule,
    isModuleInRichText,
    isGlobalGroup,
    isGlobalPartial,
    isStaticSectionModule,
    height
  } = moduleToolbarInfo || {};
  if (isPostBodyModule || isModuleInRichText) {
    return /*#__PURE__*/_jsx(ResponsiveToolbarInRichText, {
      id: id,
      responsiveSize: responsiveSize,
      isFixedPosition: isFixedPosition,
      top: Math.round(top),
      left: Math.round(left),
      toolbarHeight: Math.round(height)
    });
  }
  if (isStaticModule || isStaticSectionModule || isGlobalGroup || isGlobalPartial || isDataAuthoringModeActive) {
    return /*#__PURE__*/_jsx(ResponsiveToolbarOutsideContainer, {
      id: id,
      responsiveSize: responsiveSize,
      isFixedPosition: isFixedPosition,
      isStaticSectionModule: isStaticSectionModule,
      top: Math.round(top),
      left: Math.round(left),
      toolbarHeight: Math.round(height),
      dispatch: dispatch,
      bus: bus
    });
  } else if (isFlexColumnModule) {
    return /*#__PURE__*/_jsx(ResponsiveToolbarInFlexColumn, {
      id: id,
      responsiveSize: responsiveSize,
      isFixedPosition: isFixedPosition,
      top: Math.round(top),
      left: Math.round(left),
      toolbarHeight: Math.round(height),
      dispatch: dispatch,
      bus: bus
    });
  }
  return /*#__PURE__*/_jsx(ResponsiveToolbarInDndArea, {
    id: id,
    layoutSectionId: layoutSectionId,
    responsiveSize: responsiveSize,
    isFixedPosition: isFixedPosition,
    top: Math.round(top),
    left: Math.round(left),
    toolbarHeight: Math.round(height),
    onHandleMouseDown: handlePreDragMouseDown,
    onDropdownOpenChange: handleToolbarDropdownOpenChange,
    dispatch: dispatch,
    bus: bus,
    isCommentable: isCommentable
  });
};
const renderInsertNewSectionToolbar = (insertNewSectionToolbarInfo, bus, dispatch, handlePreDragMouseDown) => {
  // Have the default position be way off screen to prevent borders from bleeding onto the page. Plus,
  // we intentionally render offscreen instead of rendering null for perf (far less mount/unmount churn)
  const {
    id,
    layoutSectionId,
    top = OFFSCREEN_POSITION.TOP,
    left = OFFSCREEN_POSITION.LEFT,
    highlightTop = OFFSCREEN_POSITION.TOP,
    highlightLeft = OFFSCREEN_POSITION.LEFT,
    highlightWidth = 0,
    responsiveSize,
    isEmptyLayoutSection,
    targetBeforeOrAfter
  } = insertNewSectionToolbarInfo || {};
  return /*#__PURE__*/_jsx(ResponsiveInsertNewSectionHandle, {
    id: id,
    layoutSectionId: layoutSectionId,
    targetBeforeOrAfter: targetBeforeOrAfter,
    isEmptyLayoutSection: isEmptyLayoutSection,
    top: top,
    left: left,
    highlightTop: highlightTop,
    highlightLeft: highlightLeft,
    highlightWidth: highlightWidth,
    responsiveSize: responsiveSize,
    onHandleMouseDown: handlePreDragMouseDown
  });
};
const renderResponsiveEmptyContainerToolbar = (moduleToolbarInfo, bus, dispatch, handleToolbarDropdownOpenChange) => {
  // Have the default position be way off screen to prevent borders from bleeding onto the page. Plus,
  // we intentionally render offscreen instead of rendering null for perf (far less mount/unmount churn)
  const {
    id,
    layoutSectionId,
    top = OFFSCREEN_POSITION.TOP,
    left = OFFSCREEN_POSITION.LEFT,
    responsiveSize
  } = moduleToolbarInfo || {};
  return /*#__PURE__*/_jsx(ResponsiveEmptyContainerToolbar, {
    id: id,
    layoutSectionId: layoutSectionId,
    responsiveSize: responsiveSize,
    top: Math.round(top),
    left: Math.round(left),
    onDropdownOpenChange: handleToolbarDropdownOpenChange,
    dispatch: dispatch,
    bus: bus
  });
};
const renderResponsiveColumnToolbar = (columnToolbarInfo, bus, isHoveredOrSelected, dispatch, handlePreDragMouseDown, handleToolbarDropdownOpenChange) => {
  // Have the default position be way off screen to prevent borders from bleeding onto the page. Plus,
  // we intentionally render offscreen instead of rendering null for perf (far less mount/unmount churn)
  const {
    id,
    layoutSectionId,
    top = OFFSCREEN_POSITION.TOP,
    left = OFFSCREEN_POSITION.LEFT,
    responsiveSize
  } = columnToolbarInfo || {};
  return /*#__PURE__*/_jsx(ResponsiveColumnToolbar, {
    id: id,
    layoutSectionId: layoutSectionId,
    active: isHoveredOrSelected,
    responsiveSize: responsiveSize,
    top: Math.round(top),
    left: Math.round(left),
    onHandleMouseDown: handlePreDragMouseDown,
    onDropdownOpenChange: handleToolbarDropdownOpenChange,
    bus: bus,
    dispatch: dispatch
  });
};
const renderResponsiveRowToolbar = (rowToolbarInfo, bus, isHoveredOrSelected, dispatch, handlePreDragMouseDown, handleToolbarDropdownOpenChange) => {
  // Have the default position be way off screen to prevent borders from bleeding onto the page. Plus,
  // we intentionally render offscreen instead of rendering null for perf (far less mount/unmount churn)
  const {
    id,
    layoutSectionId,
    top = OFFSCREEN_POSITION.TOP,
    left = OFFSCREEN_POSITION.LEFT,
    responsiveSize
  } = rowToolbarInfo || {};
  return /*#__PURE__*/_jsx(ResponsiveRowToolbar, {
    id: id,
    layoutSectionId: layoutSectionId,
    active: isHoveredOrSelected,
    responsiveSize: responsiveSize,
    top: Math.round(top),
    left: Math.round(left),
    onHandleMouseDown: handlePreDragMouseDown,
    onDropdownOpenChange: handleToolbarDropdownOpenChange,
    bus: bus,
    dispatch: dispatch
  });
};
class LayoutSectionToolbarsContainer extends Component {
  constructor(props) {
    super(props);
    this.handlePreDragMouseDown = this.handlePreDragMouseDown.bind(this);
    this.handleNextMouseUpAnywhere = this.handleNextMouseUpAnywhere.bind(this);
    this.handleToolbarDropdownOpenChange = this.handleToolbarDropdownOpenChange.bind(this);
  }
  handlePreDragMouseDown() {
    const {
      layoutSectionHoverPositionsFrozen
    } = this.props;
    const {
      tour
    } = this.context;
    if (tour && tour.getStep() !== 'sectionDropdown') {
      layoutSectionHoverPositionsFrozen();
      window.addEventListener('mouseup', this.handleNextMouseUpAnywhere);
    }
  }
  handleNextMouseUpAnywhere() {
    const {
      layoutSectionHoverPositionsThawed
    } = this.props;
    layoutSectionHoverPositionsThawed();
    window.removeEventListener('mouseup', this.handleNextMouseUpAnywhere);
  }
  handleToolbarDropdownOpenChange(tooltipOpen) {
    const {
      layoutSectionHoverPositionsFrozen,
      layoutSectionHoverPositionsThawed
    } = this.props;
    if (tooltipOpen) {
      layoutSectionHoverPositionsFrozen();
      return;
    }
    layoutSectionHoverPositionsThawed();
  }
  render() {
    const {
      bus,
      dispatch,
      shouldShowGridAndToolbars,
      moduleToolbarInfo,
      insertNewSectionToolbarInfo,
      emptyContainerToolbarInfo,
      columnToolbarInfo,
      rowToolbarInfo,
      sectionToolbarInfo,
      hasTopmostRowToolbarHoveredOrSelected,
      hasRowToolbarHoveredOrSelected,
      hasColumnToolbarHoveredOrSelected,
      hasAllResponsiveToolbarMeasurements,
      isInDefaultBreakpointMode,
      isDataAuthoringModeActive,
      isCommentable
    } = this.props;

    // Wait for measurements before rendering any toolbars (done by ResponsiveToolbarsMeasurementsContainer)
    if (!hasAllResponsiveToolbarMeasurements) {
      return null;
    }
    if (isDataAuthoringModeActive) {
      return /*#__PURE__*/_jsx("div", {
        className: !shouldShowGridAndToolbars ? 'hs-hide' : '',
        children: renderResponsiveToolbar(moduleToolbarInfo, bus, dispatch, this.handlePreDragMouseDown, this.handleToolbarDropdownOpenChange, true, isCommentable)
      });
    }
    return /*#__PURE__*/_jsxs("div", {
      className: !shouldShowGridAndToolbars ? 'hs-hide' : '',
      children: [renderResponsiveSectionToolbar(moduleToolbarInfo, sectionToolbarInfo, bus, hasTopmostRowToolbarHoveredOrSelected, dispatch, this.handlePreDragMouseDown, this.handleToolbarDropdownOpenChange, shouldShowGridAndToolbars, isCommentable), renderResponsiveColumnToolbar(columnToolbarInfo, bus, hasColumnToolbarHoveredOrSelected, dispatch, this.handlePreDragMouseDown, this.handleToolbarDropdownOpenChange), renderResponsiveRowToolbar(rowToolbarInfo, bus, hasRowToolbarHoveredOrSelected, dispatch, this.handlePreDragMouseDown, this.handleToolbarDropdownOpenChange), renderResponsiveEmptyContainerToolbar(emptyContainerToolbarInfo, bus, dispatch), renderResponsiveToolbar(moduleToolbarInfo, bus, dispatch, this.handlePreDragMouseDown, this.handleToolbarDropdownOpenChange, false, isCommentable), isInDefaultBreakpointMode && renderInsertNewSectionToolbar(insertNewSectionToolbarInfo, bus, dispatch, this.handlePreDragMouseDown)]
    });
  }
}
LayoutSectionToolbarsContainer.contextType = TourContext;
LayoutSectionToolbarsContainer.propTypes = {
  bus: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  shouldShowGridAndToolbars: PropTypes.bool.isRequired,
  moduleToolbarInfo: PropTypes.object,
  emptyContainerToolbarInfo: PropTypes.object,
  rowToolbarInfo: PropTypes.object,
  sectionToolbarInfo: PropTypes.object,
  columnToolbarInfo: PropTypes.object,
  insertNewSectionToolbarInfo: PropTypes.object,
  hasTopmostRowToolbarHoveredOrSelected: PropTypes.bool.isRequired,
  hasRowToolbarHoveredOrSelected: PropTypes.bool.isRequired,
  hasColumnToolbarHoveredOrSelected: PropTypes.bool.isRequired,
  hasAllResponsiveToolbarMeasurements: PropTypes.bool.isRequired,
  layoutSectionHoverPositionsFrozen: PropTypes.func.isRequired,
  layoutSectionHoverPositionsThawed: PropTypes.func.isRequired,
  isInDefaultBreakpointMode: PropTypes.bool,
  isDataAuthoringModeActive: PropTypes.bool,
  isCommentable: PropTypes.bool
};
export default connect(mapStateToProps, mapDispatchToProps)(LayoutSectionToolbarsContainer);